module.exports = __webpack_public_path__ + "static/media/mariya-georgieva.a30894f5.jpg";